import LottieVuePlayer from '@lottiefiles/vue-lottie-player'
import { HalfCircleSpinner } from 'epic-spinners'
import Vue from 'vue'

Vue.component('Spinner', HalfCircleSpinner)
Vue.use(LottieVuePlayer)
